import React from 'react';

type ProductBadgeProps = {
    product: any;
};

export function ProductBadge(props: ProductBadgeProps) {
    const { product } = props;
    const en_CA = product.attributes?.certifications?.values[0]?.en_CA;

    return (
        <ul className='badges'>
            {en_CA === 'EPA-2020' && <li className='badge'>EPA 2020</li>}
        </ul>
    );
}
